module.exports = __webpack_public_path__ + "static/media/40_B.38e08ebc.png";